<template>
  <el-dialog title="订单回收站"
             :visible.sync="visible"
             width="1000px"
             center
             custom-class="default-table"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <div>
      <div>
        <el-form class="form" size="mini" inline>
          <el-form-item label="订单号">
            <el-input v-model="formSearch.order_nos" placeholder="请输入订单号" style="width: 300px" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search"
                       @click="queryRecycleBinList"
                       :loading="loading"
                       :disabled="loading">
              搜索
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-table :data="tableData" v-loading="loading" element-loading-text="加载中..."
                style="width: 100%; margin-top: 20px;">
        <el-table-column type="index" label="序号" width="70" align="center"/>
        <el-table-column prop="order_no" label="订单编号" width="180" align="center"/>
        <el-table-column prop="customer_name" label="客户名称" width="180" align="center"/>
        <el-table-column prop="payment_account" label="含税收入" header-align="center" align="right"/>
        <el-table-column prop="delete_by" label="删除人" align="center"/>
        <el-table-column prop="created_timestamp_alias" label="下单时间" width="180" align="center"/>
      </el-table>
      <Pagination
          v-show="pagingData.total>0"
          :total="pagingData.total"
          :page.sync="formSearch.page"
          :limit.sync="formSearch.per_page"
          @pagination="queryRecycleBinList"
      />
    </div>
  </el-dialog>

</template>

<script>
import {queryRecycleOrdersList} from "@/api/adOrder";

export default {
  name: "DialogRecycleBin",
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  watch: {
    show: function (v) {
      if (v) {
        this.visible = v
      }
    },
    visible: function (v) {
      if (!v) {
        this.$emit('update:show', false)
      }
    }
  },
  data() {
    return {
      visible: this.show,
      loading: true,
      formSearch: {order_nos: '', page: 1, per_page: 15},
      tableData: [],
      pagingData: {
        is_show: true,
        total: 0,
        layout: 'total, sizes, prev, pager, next, jumper',
      }
    }
  },
  mounted() {
    this.queryRecycleBinList()
  },
  methods: {
    queryRecycleBinList: function () {
      // 加载中...
      this.loading = true
      // 请求回收站数据
      const that = this;
      this.$nextTick(async function() {
        const { model } = await queryRecycleOrdersList(that.formSearch);
        that.formSearch.page = model.current_page
        that.formSearch.per_page = model.per_page
        that.pagingData.total = model.total
        that.tableData = model.data
      })
      // 加载完成...
      this.loading = false;
    },
  }
}
</script>

<style scoped>

</style>
